export class Customer {
  TTId: string;
  DCSId: string;
}

export class CustomerInfo {
  id?: number;
  name: string;
  email?: string;
  phone: string;
  taxId?: string;
  isActive?: boolean | null = null;
  address1: string;
  address2?: string | null = null;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
  createdOn?: string;
  isAgreementAccepted?: boolean = false;
  agreementAcceptedBy?: number = 0;
  agreementAcceptedOn?: Date | string | null | undefined = null;
  agreementAcceptedByName?: string;
  DCSCustomerId?: string;
  isTenantDBCreated?: boolean;
  agreementStartDate?: Date | string | null | undefined = null;
  agreementEndDate?: Date | string | null | undefined = null;
  firstBillingDate?: Date | string | null | undefined = null;
  // agreementSignDate?: Date | null = null;
  recurringBillingDay?: number = 1;
  signature?: string = '';
}

export class UpdateAgreementAcceptanceReq2 {
  id: number = 0;
  isAgreementAccepted: boolean = false;
  agreementStartDate?: Date | string | null = null;
  agreementEndDate?: Date | string | null = null;
  firstBillingDate?: Date | string | null = null;
  // agreementSignDate?: Date | null = null;
  agreementAcceptedOn?: Date | string | null = null;
  recurringBillingDay?: number = 1;
  signature?: string = '';
}

export class CustomerDetails {
  id?: number;
  name: string;
  dbaName: string;
  email?: string;
  phone: string;
  taxId: string;
  isActive?: boolean | null = null;
  address1: string;
  address2?: string | null = null;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
  createdOn?: string;
  isAgreementAccepted?: boolean = false;
  agreementAcceptedBy?: number = 0;
  agreementAcceptedOn?: string | null = null;
  agreementAcceptedByName?: string;
}

export class UpdateCustomerCommand {
  id?: number;
  name: string;
  dbaName: string;
  email?: string;
  phone: string;
  taxId: string;
  address1: string;
  city: string;
  state: string;
  zipcode: string;
}

export class CreateTenantDBAndSubscriptionCommand {
  customerId?: number;
  practiceId?: number;
}
